import { CanUsesInitialBudgets } from 'src/constants/permissionsList';

const selfPermissions = [
  'DeleteInvoicesOwn',
  'CloseOfflinePoOwned',
  'ClosePoOwned',
  'CancelPOSelf',
  'CompleteReceipts',
  'CanReceiveInvoices',
  'ReceivePoOwned',
];

export const companyAttributes = [...CanUsesInitialBudgets];

export default selfPermissions;
